function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, InputNumber, Alert, Tag, Upload } from 'antd';
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SaveEcbu = function SaveEcbu(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler,
    _ref$update = _ref.update,
    update = _ref$update === void 0 ? false : _ref$update;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    formData.append("aspect", values.aspect);
    formData.append("couleur", values.couleur);
    formData.append("leucocytes", values.leucocytes);
    formData.append("hematies", values.hematies);
    formData.append("epitheliales", values.epitheliales);
    formData.append("parasites", values.parasites);
    formData.append("levure", values.levure);
    formData.append("autres", values.autres);
    formData.append("gram", values.gram);
    formData.append("user_id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + "setecbu", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (update == true) {
      form.setFieldsValue({
        aspect: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.aspect : "",
        couleur: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.couleur : "",
        leucocytes: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.leucocytes : "",
        hematies: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.hematies : "",
        epitheliales: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.epitheliales : "",
        parasites: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.parasites : "",
        levure: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.levure : "",
        autres: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.autres : "",
        gram: candidat.laboratory_result.ecbu != null ? candidat.laboratory_result.ecbu.gram : ""
      });
    }
    form.setFieldsValue({
      comment: ""
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsxs("fieldset", {
        children: [/*#__PURE__*/_jsx("legend", {
          children: "EXAMEN MACROSCOPIQUE"
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Aspect",
          name: "aspect",
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Couleur",
          name: "couleur",
          children: /*#__PURE__*/_jsx(Input, {})
        })]
      }), /*#__PURE__*/_jsxs("fieldset", {
        children: [/*#__PURE__*/_jsx("legend", {
          children: "EXAMEN MICROSCOPIQUE - CYTOLOGIE"
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Leucocytes",
          name: "leucocytes",
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Hematies",
          name: "hematies",
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Cellules Epitheliales",
          name: "epitheliales",
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Parasites",
          name: "parasites",
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Levure",
          name: "levure",
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Autres",
          name: "autres",
          children: /*#__PURE__*/_jsx(Input, {})
        })]
      }), /*#__PURE__*/_jsxs("fieldset", {
        children: [/*#__PURE__*/_jsx("legend", {
          children: "COLORATION DE GRAM"
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "",
          name: "gram",
          children: /*#__PURE__*/_jsx(Input, {})
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })
  });
};
export default SaveEcbu;